<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal" :hide-footer="true">
            <div slot="modal-title">
                Irregularidade -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <irregularidade-form
                ref="irregularidadeForm"
                :operacao="operacao"
                :irregularidade="irregularidade"
                @fechar="fecharModal()"
                @salvar="atualizarIrregularidade($event)"
            ></irregularidade-form>
        </b-modal>
    </div>
</template>

<script>
import IrregularidadeForm from './IrregularidadeForm'
import IrregularidadesServicos from './IrregularidadesServicos'

export default {
    components: {
        IrregularidadeForm
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'ATUALIZAÇÃO'
        }
    },

    props: {
        irregularidade: {
            type: Object
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            if (this.obterIrregularidadesAtualizadas) {
                this.$emit('obterIrregularidadesAtualizadas')
            }
        },

        atualizarIrregularidade(irregularidade) {
            this.$store.dispatch('addRequest')
            IrregularidadesServicos.atualizarIrregularidade(irregularidade).then(response => {
                if (response) {
                    if (response.success) {
                        this.obterIrregularidadesAtualizadas = true
                        this.$toast.success(
                            'Registro salvo com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$refs.irregularidadeForm.resetForm()
                        this.fecharModal()
                    } else {
                        this.$refs.irregularidadeForm.setErros(response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
